import { openExternalURL } from 'utils/openExternalURL';
import { ProductImages } from './ProductImages';
import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';

export type CombinedListingSku = Pick<
  Conversation.Trade.CombinedListingSku,
  'skuId' | 'image' | 'title' | 'skuName' | 'sellerSku' | 'itemUrl' | 'skuCount'
>;

function CombinedListingSkus({
  combinedListingSkus,
}: {
  combinedListingSkus: CombinedListingSku[];
}) {
  const { t } = useTranslate();

  return (
    <Container>
      <div>{t("It's virtual bundle,included following SKUs:")}</div>
      <ul>
        {combinedListingSkus.map(
          ({ skuId, image, title, skuName, sellerSku, itemUrl, skuCount }) => {
            return (
              <li key={skuId}>
                <ProductImages platform="TIKTOK" images={[image]} />
                <section>
                  <div>
                    <p onClick={() => openExternalURL(itemUrl, '_blank')}>{title}</p>
                    <span>x{skuCount}</span>
                  </div>
                  <span>{skuName}</span>
                  <span>{`${t('SKU货号')}: ${sellerSku || '-'}`}</span>
                </section>
              </li>
            );
          },
        )}
      </ul>
    </Container>
  );
}

const Container = styled.div`
  padding: 12px 16px;
  > div {
    margin-bottom: 8px;
    font-size: 12px;
    color: var(--fett-text-primary);
  }
  > ul {
    margin: 0;
    padding: 0;
    list-style: none;
    > li {
      display: flex;
      & + li {
        margin-top: 12px;
      }
      > div {
        flex: 0 0 auto;
        margin-right: 8px;
      }
      > section {
        flex: 1 0 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        > div {
          display: flex;
          align-items: center;
          > p {
            flex: 1 0 0;
            margin-bottom: 0;
            color: var(--fett-text-primary);
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          > span {
            margin-left: 12px;
            font-size: 12px;
            color: var(--fett-text-tertiary);
          }
        }
        > span {
          font-size: 12px;
          color: var(--fett-text-tertiary);
        }
      }
    }
  }
`;

export default CombinedListingSkus;
